import { Divider, Grid, Link, makeStyles } from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import { Skeleton } from '@material-ui/lab'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import React, { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { ROUTES } from 'consts'
import { PatientsListTypes } from 'consts/copilotControlConsts'
import useCopilotPatientsList from '../../hooks/useCopilotPatientsList'
import { trackEvent } from 'utils/analyticsUtils'

const useStyles = makeStyles(() => ({
  categoriesContainer: { marginTop: 10 },
  category: { margin: 3, backgroundColor: '#F0F0F0', borderRadius: 8, padding: '5px 10px' },
  enabledCategory: { backgroundColor: '#E9FDF3' },
  link: { color: 'var(--text-color-25)', marginTop: 12, textAlign: 'left', fontSize: 14 },
  divider: { margin: '16px 0' },
  warning: { color: '#FFB632', marginRight: 10 }
}))

const CopilotUtilizationCategories = ({
  practiceGuidelinesConfiguration = [],
  briefCoverage,
  isLoadingBriefCoverage
}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { handlePatientListTypeSelected } = useCopilotPatientsList()
  const isAllEnabled =
    practiceGuidelinesConfiguration.length > 0 && practiceGuidelinesConfiguration.every(category => category.isEnabled)
  const missingCount = briefCoverage?.patientsWithoutBrief

  useEffect(() => {
    trackEvent('Copilot Control - Copilot Utilization - Viewed')
  }, [])

  return (
    <Grid container direction="column" wrap="nowrap">
      <DazzedHeading14 regular>
        {isAllEnabled
          ? t('pages.copilotControl.mainPage.copilotUtilization.allEnabled')
          : t('pages.copilotControl.mainPage.copilotUtilization.enableMore')}
      </DazzedHeading14>
      <Grid container className={classes.categoriesContainer}>
        {practiceGuidelinesConfiguration.map(category => (
          <div
            className={[classes.category, category.isEnabled ? classes.enabledCategory : ''].join(' ')}
            key={category.categoryKey}
          >
            {t(`pages.accountSettings.practiceGuidelines.categories.${category.categoryKey}.copilotUtilizationLabel`)}
          </div>
        ))}
      </Grid>
      <Link component={RouterLink} to={ROUTES.PRACTICE_GUIDELINES} underline="always" className={classes.link}>
        {t('pages.copilotControl.mainPage.copilotUtilization.viewPracticeSettings')}
      </Link>
      <Divider className={classes.divider} />
      {isLoadingBriefCoverage ? (
        <Skeleton width="100%" height={40} />
      ) : !briefCoverage ? (
        <DazzedHeading14 regular>
          {t('pages.copilotControl.mainPage.copilotUtilization.coverageUnavailable')}
        </DazzedHeading14>
      ) : missingCount > 0 ? (
        <>
          <Grid container wrap="nowrap" alignItems="center">
            <ErrorIcon className={classes.warning} fontSize="small" />
            <DazzedHeading14 regular>
              <Trans
                i18nKey="pages.copilotControl.mainPage.copilotUtilization.missingSettings"
                count={missingCount}
                components={{ bold: <strong /> }}
              />
            </DazzedHeading14>
          </Grid>
          <Link
            component="button"
            underline="always"
            className={classes.link}
            onClick={() => {
              trackEvent('Copilot Control - Missing Copilot Settings - View Patients')
              handlePatientListTypeSelected(PatientsListTypes.MissingCopilotSettings.type)
            }}
          >
            {t('pages.copilotControl.mainPage.copilotUtilization.viewPatients')}
          </Link>
        </>
      ) : (
        <DazzedHeading14 regular>
          {t(
            `pages.copilotControl.mainPage.copilotUtilization.${
              briefCoverage.activePatients ? 'allPatientsConfigured' : 'noActivePatients'
            }`
          )}
        </DazzedHeading14>
      )}
    </Grid>
  )
}

export default CopilotUtilizationCategories
